/**
 * Valor que representa a condição "desabilitado" no step de limite e notificaçoes do configurador de frequência.
 */
const DISABLED = 0;

/**
 * Valor que representa a condição "habilitar notificações gerais" no step de limite e notificaçoes
 * do configurador de frequência.
 */
const ENABLE_GENERAL = 1;

/**
 * Valor que representa a condição "habilitar notificações de alerta e atenção" no step de limite e notificaçoes
 * do configurador de frequência.
 */
const ENABLE_ALERT_LIMIT  = 2;

export default {
	DISABLED,
	ENABLE_GENERAL,
	ENABLE_ALERT_LIMIT,
};
